var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{staticClass:"stay"},[_c('header-component',{attrs:{"is-sticky":true,"logo":_vm.logoType,"content-props":{
      joinPage: true,
      hasLoginLink: true,
      inviteCode: _vm.inviteCode,
      signupPopupEnabled: true,
      cta: !_vm.isUserLoggedIn
        ? {
            copy: _vm.$t('cta'),
            openSignup: true,
            data: {
              'login-path': _vm.loginPath,
              'signup-path': _vm.signupPath
            }
          }
        : null
    }}}),_vm._v(" "),_c('section',[_c('hero-section',{staticClass:"mb-10 l:mb-7"}),_vm._v(" "),(!_vm.didUserJustLoginOrSignup)?[_c('format-banner-section'),_vm._v(" "),_c('pricing-card',{staticClass:"mt-8"}),_vm._v(" "),_c('buttons-section',{staticClass:"text-center mt-8 container",attrs:{"invite-code":_vm.inviteCode,"show-signup":!_vm.isUserLoggedIn}}),_vm._v(" "),_c('benefits',{staticClass:"mt-4"}),_vm._v(" "),_c('organisations-category-explorer',{attrs:{"categories":_vm.categoryProps}}),_vm._v(" "),_c('app-reviews',{attrs:{"show-trial-end-date":false,"modifiers":['pt-0']},scopedSlots:_vm._u([{key:"cta",fn:function(){return [_c('buttons-section',{attrs:{"invite-code":_vm.inviteCode,"show-signup":!_vm.isUserLoggedIn}})]},proxy:true}],null,false,3462727967)}),_vm._v(" "),_c('faq',{attrs:{"type":"b2cMultiUserPlan"}})]:_vm._e()],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }